import { createGlobalStyle } from 'styled-components';

import AkkuratLLBlackWoff from '../fonts/AkkuratLL/AkkuratLL-Black.woff';
import AkkuratLLBlackWoff2 from '../fonts/AkkuratLL/AkkuratLL-Black.woff2';
import AkkuratLLBlackItalicWoff from '../fonts/AkkuratLL/AkkuratLL-BlackItalic.woff';
import AkkuratLLBlackItalicWoff2 from '../fonts/AkkuratLL/AkkuratLL-BlackItalic.woff2';
import AkkuratLLBoldWoff from '../fonts/AkkuratLL/AkkuratLL-Bold.woff';
import AkkuratLLBoldWoff2 from '../fonts/AkkuratLL/AkkuratLL-Bold.woff2';
import AkkuratLLBoldItalicWoff from '../fonts/AkkuratLL/AkkuratLL-BoldItalic.woff';
import AkkuratLLBoldItalicWoff2 from '../fonts/AkkuratLL/AkkuratLL-BoldItalic.woff2';
import AkkuratLLItalicWoff from '../fonts/AkkuratLL/AkkuratLL-Italic.woff';
import AkkuratLLItalicWoff2 from '../fonts/AkkuratLL/AkkuratLL-Italic.woff2';
import AkkuratLLLightWoff from '../fonts/AkkuratLL/AkkuratLL-Light.woff';
import AkkuratLLLightWoff2 from '../fonts/AkkuratLL/AkkuratLL-Light.woff2';
import AkkuratLLLightItalicWoff from '../fonts/AkkuratLL/AkkuratLL-LightItalic.woff';
import AkkuratLLLightItalicWoff2 from '../fonts/AkkuratLL/AkkuratLL-LightItalic.woff2';
import AkkuratLLRegularWoff from '../fonts/AkkuratLL/AkkuratLL-Regular.woff';
import AkkuratLLRegularWoff2 from '../fonts/AkkuratLL/AkkuratLL-Regular.woff2';
import AkkuratLLThinWoff from '../fonts/AkkuratLL/AkkuratLL-Thin.woff';
import AkkuratLLThinWoff2 from '../fonts/AkkuratLL/AkkuratLL-Thin.woff2';
import AkkuratLLThinItalicWoff from '../fonts/AkkuratLL/AkkuratLL-ThinItalic.woff';
import AkkuratLLThinItalicWoff2 from '../fonts/AkkuratLL/AkkuratLL-ThinItalic.woff2';
import PPEditorialNewLightWoff from '../fonts/PPEditorialNew/PPEditorialNew-Light.woff';
import PPEditorialNewLightWoff2 from '../fonts/PPEditorialNew/PPEditorialNew-Light.woff2';
import PPEditorialNewUltralightWoff from '../fonts/PPEditorialNew/PPEditorialNew-Ultralight.woff';
import PPEditorialNewUltralightWoff2 from '../fonts/PPEditorialNew/PPEditorialNew-Ultralight.woff2';
import PPEditorialNewUltralightItalicWoff from '../fonts/PPEditorialNew/PPEditorialNew-UltralightItalic.woff';
import PPEditorialNewUltralightItalicWoff2 from '../fonts/PPEditorialNew/PPEditorialNew-UltralightItalic.woff2';

export const GlobalStyles = createGlobalStyle(
  ({ theme }) => `
  @font-face {
    font-family: 'PPEditorial New';
    font-weight: 300; /* Specify weight for Light */
    font-style: normal;
    src: url('${PPEditorialNewLightWoff}') format('woff2'),
         url('${PPEditorialNewLightWoff2}') format('woff');
    font-display: swap;
  }

  @font-face {
    font-family: 'PPEditorial New';
    font-weight: 200; /* Specify weight for Ultralight */
    font-style: normal;
    src: url('${PPEditorialNewUltralightWoff}') format('woff2'),
         url('${PPEditorialNewUltralightWoff2}') format('woff');
    font-display: swap;
  }

  @font-face {
    font-family: 'PPEditorial New';
    font-weight: 200; /* Match the ultralight weight */
    font-style: italic;
    src: url('${PPEditorialNewUltralightItalicWoff}') format('woff2'),
         url('${PPEditorialNewUltralightItalicWoff2}') format('woff');
    font-display: swap;
  }
    
  @font-face {
    font-family: 'Akkurat LL';
    font-weight: 100;
    src: url('${AkkuratLLThinWoff2}') format('woff2'),
         url('${AkkuratLLThinWoff}')) format('woff');
  }

  @font-face {
    font-family: 'Akkurat LL';
    font-weight: 200 300;
    src: url('${AkkuratLLLightWoff2}') format('woff2'),
         url('${AkkuratLLLightWoff}')) format('woff');
  }

  @font-face {
    font-family: 'Akkurat LL';
    font-weight: 400 500;
    src: url('${AkkuratLLRegularWoff2}') format('woff2'),
         url('${AkkuratLLRegularWoff}')) format('woff');
  }

  @font-face {
    font-family: 'Akkurat LL';
    font-weight: 600 800;
    src: url('${AkkuratLLBoldWoff2}') format('woff2'),
         url('${AkkuratLLBoldWoff}')) format('woff');
  }

  @font-face {
    font-family: 'Akkurat LL';
    font-weight: 900 1000;
    src: url('${AkkuratLLBlackWoff2}') format('woff2'),
         url('${AkkuratLLBlackWoff}')) format('woff');
  }

  @font-face {
    font-family: 'Akkurat LL';
    font-style: italic;
    font-weight: 100;
    src: url('${AkkuratLLThinItalicWoff2}') format('woff2'),
         url('${AkkuratLLThinItalicWoff}')) format('woff');
  }

  @font-face {
    font-family: 'Akkurat LL';
    font-style: italic;
    font-weight: 200 300;
    src: url('${AkkuratLLLightItalicWoff2}') format('woff2'),
         url('${AkkuratLLLightItalicWoff}')) format('woff');
  }

  @font-face {
    font-family: 'Akkurat LL';
    font-style: italic;
    font-weight: 400 500;
    src: url('${AkkuratLLItalicWoff2}') format('woff2'),
         url('${AkkuratLLItalicWoff}')) format('woff');
  }

  @font-face {
    font-family: 'Akkurat LL';
    font-style: italic;
    font-weight: 600 800;
    src: url('${AkkuratLLBoldItalicWoff2}') format('woff2'),
         url('${AkkuratLLBoldItalicWoff}')) format('woff');
  }

  @font-face {
    font-family: 'Akkurat LL';
    font-style: italic;
    font-weight: 900 1000;
    src: url('${AkkuratLLBlackItalicWoff2}') format('woff2'),
         url('${AkkuratLLBlackItalicWoff}')) format('woff');
  }

  body,
  html {
    margin: 0;
    padding: 0;
    background: black;

  }

  * {
    font-family: ${theme.fonts};
    box-sizing: border-box;
  }
`,
);
